import { Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/components/Page";
import ImrStrategyTable from "@/components/Strategy/ImrStrategyTable";

function EconomicZonePage() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Økonomisk sone
      </Typography>
      <ImrStrategyTable />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/strategi/economic-zone")({
  component: EconomicZonePage,
});
